import React, { useState } from 'react';
import { ImageModal } from '../../layouts/Modal';
import LazyImage from '../common/LazyImage';

const PhotoGrid = ({ photos,copyPhotos }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="relative group overflow-hidden rounded-lg aspect-[4/4] cursor-pointer"
            onClick={() => setSelectedImage(photo)}
          >
            <LazyImage 
              src={photo} 
              placeholderImage={copyPhotos}
              alt={`Gallery ${index + 1}`}
              className="w-full h-full"
            />
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300" />
          </div>
        ))}
      </div>

      <ImageModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        imgSrc={selectedImage}
      />
    </>
  );
};

export default PhotoGrid;